import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, InfoWrapper, Table } from 'components';
import { FieldType, MediaGroup, UploadMedia } from 'constants/inspections';
import { tipologiaPulvinoOptions } from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import { GridWrap } from './AppoggiForm.styles';
import PulviniForm from './PulviniForm';
const PulviniSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const spallePileCollegamentiTablePulviniTableWatch = watch(
    `spallePileCollegamentiTable[${selectedIdx}].pulviniTable`
  );

  // table setup
  const dataConfigPulvini = {
    columns: {
      codice: { label: 'Codice' },
      tipologiaPulvino: {
        label: 'Tipologia',
        format: tipologiaPulvinoOptions,
      },
      altezzaPulvino: { label: 'H [cm]' },
      larghezzaPulvino: { label: 'L [cm]' },
      profonditaPulvino: { label: 'P [cm]' },
      profonditaAppoggioPulvino: { label: 'Pa [cm]' },
      superficiePulvino: { label: 'Sup. [m²]' },
    },
  };

  // pulvini setup
  const [selectedPulvini, setSelectedPulvini] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsPulvini = item => {
    setValue('l0t2a4_pulviniTableValue', [item]);
    setValue('l0t2a4_tipologiaPulvinoTableValue', item.tipologiaPulvino);
    setValue('l0t2a4_altezzaPulvinoTableValue', item.altezzaPulvino);
    setValue('l0t2a4_larghezzaPulvinoTableValue', item.larghezzaPulvino);
    setValue('l0t2a4_profonditaPulvinoTableValue', item.profonditaPulvino);
    setValue(
      'l0t2a4_profonditaAppoggioPulvinoTableValue',
      item.profonditaAppoggioPulvino
    );
    setValue('l0t2a4_superficiePulvinoTableValue', item.superficiePulvino);
  };
  const handleSelectAllClickPulvini = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `spallePileCollegamentiTable[${selectedIdx}].pulviniTable`
      );
      setSelectedPulvini(selectedValue);
      setValue('l0t2a4_pulviniTableValue', selectedValue);
    } else {
      setSelectedPulvini([]);
      setValue('l0t2a4_pulviniTableValue', []);
    }
  };

  return (
    <>
      <GridWrap container spacing={2} style={{ marginTop: 16 }}>
        <InfoWrapper
          isDivider={true}
          size={12}
          infoDrawer={true}
          drawerTitle={INFO.collegamentiPulvini.drawerTitle}
          drawerText={INFO.collegamentiPulvini.drawerText}
        >
          <Divider>PULVINI</Divider>
        </InfoWrapper>
        {spallePileCollegamentiTablePulviniTableWatch?.length === 0 && (
          <GridWrap item xs={12} paddingTop={'0px !important'}>
            <Typography>Nessun pulvino presente in questo elemento</Typography>
          </GridWrap>
        )}
      </GridWrap>
      {spallePileCollegamentiTablePulviniTableWatch?.length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <PulviniForm
              pulviniFields={spallePileCollegamentiTablePulviniTableWatch || []}
              selected={selectedPulvini}
              setSelected={setSelectedPulvini}
              pulviniTable={`spallePileCollegamentiTable[${selectedIdx}].pulviniTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Pulvini'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`spallePileCollegamentiTable[${selectedIdx}].pulviniTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Struttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={spallePileCollegamentiTablePulviniTableWatch || []}
                config={dataConfigPulvini}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsPulvini(item);
                            setSelectedPulvini([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        spallePileCollegamentiTablePulviniTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedPulvini}
                onSelectAllClick={handleSelectAllClickPulvini}
                setSelected={setSelectedPulvini}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
PulviniSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default PulviniSection;
